"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SearchInput", {
  enumerable: true,
  get: function () {
    return _SearchInput.SearchInput;
  }
});
var _SearchInput = require("./SearchInput");